import { useTranslation } from 'react-i18next';

const icons = [
  'ri-grid-line',
  'ri-search-eye-line',
  'ri-truck-line',
  'ri-shield-check-line',
];

const colors = [
  'bg-primary-100 text-primary-700',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-100 text-accent-700',
  'bg-primary-100 text-primary-700',
];

export default function TrustStrip() {
  const { t } = useTranslation();

  const items = [
    { title: t('trust.1.title'), desc: t('trust.1.desc') },
    { title: t('trust.2.title'), desc: t('trust.2.desc') },
    { title: t('trust.3.title'), desc: t('trust.3.desc') },
    { title: t('trust.4.title'), desc: t('trust.4.desc') },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item, idx) => (
            <div key={idx} className="flex items-start gap-3 p-5 rounded-lg bg-background-100 border border-background-200">
              <span className={`w-11 h-11 flex items-center justify-center rounded-lg shrink-0 ${colors[idx]}`}>
                <i className={`${icons[idx]} text-xl`} />
              </span>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}